import lozad from "./lozad.min.js";

import initGalleries from "./contactform";

const initLozad = () => {
  let elements = document.querySelectorAll("img.lazy-load");
  if (elements) {
    Array.prototype.forEach.call(elements, element => {
      lozad(element, {
        rootMargin: "768px 0px",
        loaded: function(el) {
          el.classList.add("is-loaded");
          initGalleries();
        }
      }).observe();
    });
  }

  elements = document.querySelectorAll("img[data-full-url]");
  if (elements) {
    Array.prototype.forEach.call(elements, element => {
      lozad(element, {
        rootMargin: "768px 0px",
        loaded: function(el) {
          if (el) {
            let src = el.getAttribute("data-full-url");
            if (src && src.length) {
              el.setAttribute("src", src);
              // el.setAttribute("srcset", "");
              el.removeAttribute("srcset");
            }
          }
          el.classList.add("is-loaded");
        }
      }).observe();
    });
  }
};

export default initLozad;
